import styled from 'styled-components';

export const StyledRequestSubmitted = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  .request-submitted__icon {
    width: 64px;
    height: 64px;
    margin-bottom: ${(props): string => props.theme.kcc.spacing.LG};

    svg {
      width: 64px;
      height: 64px;
    }

    svg path {
      fill: ${(props): string => props.theme.kcc.colors.TEXT};
    }
  }

  .request-submitted__title {
    margin-bottom: ${(props): string => props.theme.kcc.spacing.XS};
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.HEADING_3}px;
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
  }

  .request-submitted__subtitle {
    margin-bottom: 0;
    color: ${(props): string => props.theme.kcc.colors.TEXT_SECONDARY};
  }
`;
